import {
    deleteHeaders,
    fetchHeaders,
    patchHeaders,
    postHeaders,
} from "../../utils/headers";
import Constants from "../../utils/constants";

export const campaignsService = {
    fetchCampaigns,
    fetchCampaign,
    deleteCampaign,
    createCampaign,
    updateCampaign,
    fetchDetails
};

function fetchCampaigns() {
    const requestOptions = fetchHeaders()

    return fetch(Constants.API_ROUTE_CAMPAIGNS, requestOptions)
        .then(handleResponse)
        .then(campaigns => {
            return campaigns["hydra:member"]
        });
}

function fetchCampaign(id, serializationGroup = null) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_CAMPAIGN.replace(':id', id);
    if (serializationGroup) {
        url += `?groups=${encodeURIComponent(serializationGroup)}`;
    }

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(campaign => {
            return campaign
        });
}

function createCampaign(values) {
    // If it's a graffiti tour, send minimal allowed payload to TourneeGraffiti endpoint
    if (values?.type === 'graffiti') {
        const payload = {
            libelle: values.libelle,
            dateDebut: values.dateDebut,
            dateFin: values.dateFin,
            client: values.client,
            patrimoine: values.patrimoine,
            rrule: values.rrule,
            chauffeur: values.chauffeur,
            equipier: values.equipier ?? null,
        };
        const requestOptions = postHeaders(payload);
        const url = Constants.API_ROUTE_TOURNEES_GRAFFITI;
        return fetch(url, requestOptions)
            .then(handleResponse)
            .then(() => "ok");
    }

    const requestOptions = postHeaders(values)
    let url = Constants.API_ROUTE_CAMPAIGNS;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function updateCampaign(values) {
    // If it's a graffiti tour, send minimal allowed payload to TourneeGraffiti endpoint
    if (values?.type === 'graffiti') {
        const payload = {
            libelle: values.libelle,
            dateDebut: values.dateDebut,
            dateFin: values.dateFin,
            client: values.client,
            patrimoine: values.patrimoine,
            rrule: values.rrule,
            chauffeur: values.chauffeur,
            equipier: values.equipier ?? null,
        };
        const requestOptions = patchHeaders(payload);
        const url = Constants.API_ROUTE_TOURNEE_GRAFFITI.replace(':id', values.id);
        return fetch(url, requestOptions)
            .then(handleResponse)
            .then(() => "ok");
    }

    const requestOptions = patchHeaders(values)
    let url = Constants.API_ROUTE_CAMPAIGN.replace(':id', values.id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok"
        });
}

function fetchDetails(date, tourneeId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_CAMPAIGN_DETAILS_CONTENEURS_INTERVENTIONS.replace(':id', tourneeId).replace(":date", date);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data
        });
}

function deleteCampaign(id) {
    const requestOptions = deleteHeaders()

    let url = Constants.API_ROUTE_CAMPAIGN.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return id
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {

            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
